export default class pararax3d {

    constructor() {

        this.$container = document.querySelectorAll('.js__3d-area');
        this.matrixValues = {
            "layer0": [
                2, 0, 0, 0,
                0, 1, 0, 0,
                0, 0, 1, 0,
                1, 1, 1, 1,
            ],
        };
        this.mouse = {
            incX:0,
                incY:0,
                nowX:0,
                nowY:0
        };
        this.xy = [];


    }
    init() {

        this.$container = document.querySelectorAll('.js__3d-area');

    }
    moveMouse(x,y,type) {


        this.mouse.incX = x;
        this.mouse.incY = y;

        let targetWidth = window.innerWidth;
        let targetHeight = window.innerHeight;
        let centeredXPos = -x + (targetWidth / 2);
        let centeredYPos = -y + (targetHeight / 2);

        centeredXPos = centeredXPos.map(-(targetWidth / 2), targetWidth / 2, Math.PI, 2 * Math.PI);
        centeredYPos = centeredYPos.map(-(targetHeight / 2), targetHeight / 2, Math.PI, 2 * Math.PI);
        centeredXPos = Math.cos(centeredXPos);
        centeredYPos = Math.cos(centeredYPos);
        let wrapper = this.$container.find(".js__3d-trans,.js__dir-y-3d");

        if(type=="out"){
            return this.transNum(this.matrixValues["layer0"], centeredYPos * 10, centeredXPos * 10, 0);
        }else{
            this.trans(wrapper, this.matrixValues["layer0"], centeredYPos * 10, centeredXPos * 10, 0);
        }

    }
    trans(target, matrix, x, y, z) {

        x = x * Math.PI / 180;
        y = y * Math.PI / 180;
        z = z * Math.PI / 180;
        var sin = Math.sin;
        var cos = Math.cos;
        matrix[0] = cos(y) * cos(z);
        matrix[1] = -cos(y) * sin(z);
        matrix[2] = sin(y);
        matrix[3] = 0;
        matrix[4] = cos(x) * sin(z) + sin(x) * sin(y) * cos(z);
        matrix[5] = cos(x) * cos(z) - sin(x) * sin(y) * sin(z);
        matrix[6] = -sin(x) * cos(y);
        matrix[7] = 0;
        matrix[8] = sin(x) * sin(z) - cos(x) * sin(y) * cos(z);
        matrix[9] = sin(x) * cos(z) + cos(x) * sin(y) * sin(z);
        matrix[10] = cos(x) * cos(y);
        matrix[11] = 0;
        this.applyTransform(target, matrix);
    }

    transNum(matrix, x, y, z) {

        x = x * Math.PI / 180;
        y = y * Math.PI / 180;
        z = z * Math.PI / 180;
        var sin = Math.sin;
        var cos = Math.cos;
        matrix[0] = cos(y) * cos(z);
        matrix[1] = -cos(y) * sin(z);
        matrix[2] = sin(y);
        matrix[3] = 0;
        matrix[4] = cos(x) * sin(z) + sin(x) * sin(y) * cos(z);
        matrix[5] = cos(x) * cos(z) - sin(x) * sin(y) * sin(z);
        matrix[6] = -sin(x) * cos(y);
        matrix[7] = 0;
        matrix[8] = sin(x) * sin(z) - cos(x) * sin(y) * cos(z);
        matrix[9] = sin(x) * cos(z) + cos(x) * sin(y) * sin(z);
        matrix[10] = cos(x) * cos(y);
        matrix[11] = 0;
        //console.log(matrix.toString());
        //return "matrix3d(" + matrix.toString() + ")";
        return matrix;
    }

    rotateX(target, angle) {
        var radians = angle * Math.PI / 180;
        var sin = Math.sin;
        var cos = Math.cos;
        this.matrixValues[5] = cos(radians);
        this.matrixValues[6] = sin(radians);
        this.matrixValues[8] = sin(radians);
        this.matrixValues[9] = cos(radians);
        this.applyTransform(target);
    }
    rotateX(target, angle) {
        var radians = angle * Math.PI / 180;
        var sin = Math.sin;
        var cos = Math.cos;
        this.matrixValues[5] = cos(radians);
        this.matrixValues[6] = sin(radians);
        this.matrixValues[8] = sin(radians);
        this.matrixValues[9] = cos(radians);
        this.applyTransform(target);
    }
    rotateY(target, angle) {
        var radians = angle * Math.PI / 180;
        var sin = Math.sin;
        var cos = Math.cos;
        this.matrixValues[0] = cos(radians);
        this.matrixValues[2] = sin(radians);
        this.matrixValues[7] = -sin(radians);
        this.matrixValues[9] = cos(radians);
        this.applyTransform(target);
    }
    rotateZ(target, angle) {
        var radians = angle * Math.PI / 180;
        var sin = Math.sin;
        var cos = Math.cos;
        this.matrixValues[0] = cos(radians);
        this.matrixValues[1] = -sin(radians);
        this.matrixValues[4] = sin(radians);
        this.matrixValues[5] = cos(radians);
        this.applyTransform(target);
    }
    matrix3dTrans(matrix){
        return matrix;
    }
    applyTransform(target, matrix) {
        var matrix3d = "matrix3d(" + matrix.toString() + ")";
        target.css({
            '-webkit-transform': matrix3d,
            '-moz-transform': matrix3d,
            '-ms-transform': matrix3d,
            '-o-transform': matrix3d,
            'transform': matrix3d
        });
    }


}

Number.prototype.map = function(in_min, in_max, out_min, out_max) {
    return (this - in_min) * (out_max - out_min) / (in_max - in_min) + out_min;
}

